import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import LangSelector from 'components/common/LangSelector'
import i18nActions from 'redux/actions/i18nActions'
import './styles.scss'

const ALLOWED_LANGS = ['es', 'en', 'ca', 'de', 'fr']

/**
 * Landing and login locale
 * @param {object} props
 * @param {'top'|'bottom'} [props.direction]
 * @param {boolean} [props.hiddenFlags = true]
 * @param {boolean} [props.darkMode = false]
 */
const LandingLocale = (props) => {
  const { direction = 'bottom', hiddenFlags = true, darkMode = false } = props

  const locale = useSelector(store => store.i18n?.locale)
  const dispatch = useDispatch()

  const onChange = useCallback((item) => {
    if (!item || !item?.value) return

    if (locale !== item.value) {
      dispatch(i18nActions.updateText({ locale: item.value }))
    }
  }, [locale, dispatch])

  return (
    <div className='landing_language_selector'>
      <LangSelector
        allowed={ALLOWED_LANGS}
        value={locale}
        hiddenFlags={hiddenFlags}
        direction={direction}
        onChange={onChange}
        darkMode={darkMode}
      />
    </div>
  )
}

export default LandingLocale